import React from 'react';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ForArchitectsPage() {
  return <>
      <SEO title="Aspect for Architects" description="Document completed work with full attribution, review control, and no coordination burden." data-id="element-143" />
      <div className="space-y-24 md:space-y-32" data-id="element-144">
        {/* Intro */}
        <section className="max-w-2xl" data-id="element-145">
          <span className="text-aspect-gray block mb-4" data-id="element-146">For Architects</span>
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-147">
            Document completed work with full attribution, review control, and
            no coordination burden.
          </h1>
          <div className="mt-10" data-id="element-148">
            <Link to="/architects/submit" data-id="element-149">
              <Button variant="primary" icon data-id="element-150">
                Submit a project
              </Button>
            </Link>
          </div>
        </section>

        {/* Why Architects Participate */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-151">
          <div className="md:col-span-4" data-id="element-152">
            <span className="text-aspect-gray" data-id="element-153">Value</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-154">
            <h2 className="text-2xl font-medium" data-id="element-155">Why Architects Participate</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-156">
              <p data-id="element-157">
                Aspect documents completed projects once, with attribution and
                control built in.
              </p>
              <p data-id="element-158">
                No repeated requests. No coordination burden. No ambiguity about
                credit or usage.
              </p>
            </div>
          </div>
        </section>

        {/* What Architects Control */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-159">
          <div className="md:col-span-4" data-id="element-160">
            <span className="text-aspect-gray" data-id="element-161">Control</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-162">
            <h2 className="text-2xl font-medium" data-id="element-163">What Architects Control</h2>
            <ul className="space-y-2 text-aspect-black/80 max-w-xl" data-id="element-164">
              <li data-id="element-165">Which projects are documented</li>
              <li data-id="element-166">Review and approval before publication</li>
              <li data-id="element-167">Attribution requirements</li>
              <li data-id="element-168">Visibility and context</li>
            </ul>
          </div>
        </section>

        {/* Attribution */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-169">
          <div className="md:col-span-4" data-id="element-170">
            <span className="text-aspect-gray" data-id="element-171">Attribution</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-172">
            <h2 className="text-2xl font-medium" data-id="element-173">Attribution & Credit</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-174">
              <p data-id="element-175">Attribution is embedded in every asset.</p>
              <p data-id="element-176">Credit follows the image wherever it is used.</p>
            </div>
          </div>
        </section>

        {/* No Coordination */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-177">
          <div className="md:col-span-4" data-id="element-178">
            <span className="text-aspect-gray" data-id="element-179">Process</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-180">
            <h2 className="text-2xl font-medium" data-id="element-181">No Coordination Burden</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-182">
              <p data-id="element-183">Aspect handles:</p>
              <ul className="space-y-2 text-aspect-black/80" data-id="element-184">
                <li data-id="element-185">Photographer coordination</li>
                <li data-id="element-186">Owner permissions</li>
                <li data-id="element-187">Product verification</li>
                <li data-id="element-188">Rights management</li>
                <li data-id="element-189">Licensing and distribution</li>
              </ul>
            </div>
          </div>
        </section>

        {/* What Architects Are Not Asked to Do */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-190">
          <div className="md:col-span-4" data-id="element-191">
            <span className="text-aspect-gray" data-id="element-192">Scope</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-193">
            <h2 className="text-2xl font-medium" data-id="element-194">
              What Architects Are Not Asked to Do
            </h2>
            <ul className="space-y-2 text-aspect-gray max-w-xl" data-id="element-195">
              <li data-id="element-196">Arrange photography</li>
              <li data-id="element-197">Manage manufacturer requests</li>
              <li data-id="element-198">Track downstream usage</li>
            </ul>
          </div>
        </section>

        {/* Participation Process */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-199">
          <div className="md:col-span-4" data-id="element-200">
            <span className="text-aspect-gray" data-id="element-201">Participation</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-202">
            <h2 className="text-2xl font-medium" data-id="element-203">Participation Process</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-204">
              <p data-id="element-205">Submit a completed or substantially complete project.</p>
              <p data-id="element-206">Aspect reviews, coordinates, and documents.</p>
              <div className="pt-4" data-id="element-207">
                <Link to="/architects/submit" data-id="element-208">
                  <Button variant="primary" icon data-id="element-209">
                    Submit a project
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>;
}